<template>
  <b-container id="maindiv">

    <section>
      <b-row>
        <div class="col-md-8">
          <h2>{{$lang('timesheets')}}</h2>
          <p class="my-3">{{$lang('description')}}</p>
        </div>
        <div class="col-md-4">
          <div class="toolbar" v-if='!error && loaded'>
            <button class="btn btn-primary shadow-sm mt-2" @click="addTimesheet()">{{$lang('timesheetNew')}}</button>
          </div>
        </div>
      </b-row>
    </section>

    <section id="mainsection">
      <div id="content" v-if='!error'>
        <b-table striped hover head-variant="dark" primary-key="id" :items="timesheetList" stacked="md" :fields="timesheetFields" :current-page="currentPage" :per-page="perPage" :busy="wait">
          <template slot="s_s" slot-scope="row">
            <a :href="'/#/timesheet/'+row.item.id">
              <div class="state">
                <i class="fa fa-circle-o mr-1" v-bind:style="{'color': row.item.s_sclr}"></i>{{row.item.s_s}}
              </div>
            </a>
          </template>   
          <div slot="table-busy" class="text-center text-muted my-5">
             <b-spinner class="align-middle"></b-spinner>
             <strong>Loading...</strong>
          </div>          
        </b-table>
        <b-row>
          <b-col md="6" class="my-4">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>        
      </div>
    </section>

    <b-alert v-if="error" class="mt-5 text-center" show variant="warning">{{error}}</b-alert>

    <b-modal v-bind:busy="form.wait" no-close-on-backdrop id="modal-14" :title="$lang('timesheetNew')" @ok.prevent="handleOk" :ok-title="$lang('ok')" :cancel-title="$lang('cancel')">
      <TimesheetItem v-bind:item=form></TimesheetItem>
    </b-modal>

    <section>
    </section>
    
  </b-container>
</template>


<script>
import axios from 'axios';
import TimesheetItem from "./TimesheetItem.vue";
export default {
  created() {
    this.fetchList()
  },
  data() {
    return {
      form: {
        id: -1,
        weeks: [],
        result: null,
        wait: null,
        error: null,
      },
      timesheetList: [],
      timesheetFields: [
        {key: "s_s", label: this.$lang("state" )},
        {key: "weekdd", label:this.$lang("week" )},
        {key: "d1_len", label:this.$lang("d1")},
        {key: "d2_len", label:this.$lang("d2")},
        {key: "d3_len", label:this.$lang("d3")},
        {key: "d4_len", label:this.$lang("d4")},
        {key: "d5_len", label:this.$lang("d5")},
        {key: "d6_len", label:this.$lang("d6")},
        {key: "d7_len", label:this.$lang("d7")},
        {key: "remark", label:this.$lang("remark")},
      ],
      totalRows: 30,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      wait: true,      
      error: null,
      loaded: false,
    };
  },
  components: { TimesheetItem },
  methods: {
    addTimesheet() {
      this.form.wait = null;
      this.form.error = null;
      this.defineWeek();
    },
    defineWeek() {
       axios.get("/api/GetOperationData?contextoid=2130013&method=available_weeks")
         .then(resp => {
            let w = resp.data;
            for(var i = 0; i < w.length; i++) {
               w[i].key = {dd: w[i].dd, month_end: w[i].month_end};
            };
            this.form.weeks = w;
            if (w.length > 0) {
               this.form.result = w[0].key;
            }
            this.$bvModal.show("modal-14");
         }).catch(err => {
            if (err.response.status == 401)
              this.$router.push('/')
            else {
              let errormsg = err.message;
              if (err.response && err.response.data.message) {
                  errormsg = err.response.data.message;
              }
              this.$bvToast.toast(errormsg, {title: "Error", variant: "danger"});
            }
         })
    },
    fetchList() {
      this.loaded = false;
      axios.get("/api/GetTimesheetList")
         .then(resp => {
            this.timesheetList = resp.data;
            this.totalRows = this.timesheetList.length;
            this.wait = null;
            this.error = null;
            this.loaded = true;
         }).catch(err => {
            if (err.response.status == 401)
              this.$router.push('/')
            else {
                let errormsg = err.message;
                if (err.response && err.response.data.message) {
                   errormsg = err.response.data.message;
                }
                this.error = errormsg;
            }
         })
    },
    async handleOk(evt) {
      this.form.wait = true;
      this.form.error = null;
      let form = evt.vueTarget.$refs.body.firstChild
      if (!form.checkValidity()){
         form.classList.add('was-validated');
         this.form.wait = null
         return;
      }
      var data2save = {
        dd: this.form.result.dd,
        month_end: this.form.result.month_end
      }
      axios.post('/api/PostOperationData?contextoid=2130013&method=add_week', data2save) 
        .then(answ => {
          this.$bvModal.hide("modal-14");
          this.$router.push("/timesheet/"+answ.data.result)
        })
        .catch(error => {
          this.form.wait = null;
          this.form.error = error.message;
          if (error.response.data.message) {
             this.form.error = error.response.data.message;
          }
        });
    },
  },
  locales: {
    en: {
        timesheets: "Time Sheets",
        timesheetNew: "New Time Sheet",
        state: "State",
        remark: "Remark",
        ok: "OK",
        cancel: "Cancel",
        week: "Week",
        d1: "Monday",
        d2: "Tuesday",
        d3: "Wednesday",
        d4: "Thursday",
        d5: "Friday",
        d6: "Saturday",
        d7: "Sunday",
        description: "The time sheet document allows you to apply an electronic report for the working week on hours worked for a temporary employment agency."
      },
    de: {
        timesheets: "Stundennachweis",
        timesheetNew: "Neuer Stundennachweis",
        state: "Zustand",
        remark: "Bemerkungen",
        ok: "OK",
        cancel: "Abbrechen",
        week: "Woche",
        d1: "Montag",
        d2: "Dienstag",
        d3: "Mittwoch",
        d4: "Donnerstag",
        d5: "Freitag",
        d6: "Samstag",
        d7: "Sonntag",
        description: "Mit dem Stundennachweis können Sie einen elektronischen Bericht über die Arbeitsstunden eines Zeitarbeitsunternehmens für die Arbeitswoche erstellen."
    },
    ru: {
        timesheets: "Отчет о рабочем времени",
        timesheetNew: "Новый отчет о рабочем времени",
        state: "Состояние",
        remark: "Примечание",
        ok: "OK",
        cancel: "Отмена",
        week: "Неделя",
        d1: "Понедельник",
        d2: "Вторник",
        d3: "Среда",
        d4: "Четверг",
        d5: "Пятница",
        d6: "Суббота",
        d7: "Воскресенье",
        description: "Отчет о рабочем времени позволяет оформить в электронном виде отчет за прошедшую рабочую неделю об отработанных часах для агенства временного трудоустройства."
    },
    pl: {
        timesheets: "Raport czasowy",
        timesheetNew: "Nowy raport czasowy",
        state: "Stan",
        remark: "Uwagi",
        ok: "OK",
        cancel: "Anulować",
        week: "Tydzień",
        d1: "Poniedziałek",
        d2: "Wtorek",
        d3: "Środa",
        d4: "Czwartek",
        d5: "Piątek",
        d6: "Sobota",
        d7: "Niedziela",
        description: "Raport czasu pracy pozwala na elektroniczne wygenerowanie raportu za miniony tydzień pracy na temat godzin przepracowanych dla agencji pracy tymczasowej."
    }  
  }
};
</script>

<style>

.toolbar {
  padding: 0 0 30px 0;
  display: flex;
  justify-content: flex-end;
}

.state {
  white-space: nowrap;
} 

</style>


// WEBPACK FOOTER //
// src/Timesheets.vue